import { Box, CircularProgress, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { VoiceEngine } from '@/apis/agency/voiceEngines/types';
export interface VoiceEngineUpdateLoadingModalProps {
  open: boolean;
  onClose: () => void;
  engine: VoiceEngine;
}

export default function VoiceEngineUpdateLoadingModal({ open, onClose, engine }: VoiceEngineUpdateLoadingModalProps) {
  const friendly = engine.configuration?.friendly_name ?? 'Voice Engine';
  const newV = engine.latest_version;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: '650px',
          maxWidth: '100%',
          borderRadius: 2,
          p: { xs: 2, sm: 3 },
          position: 'relative',
          textAlign: 'center'
        }
      }}
    >
      <IconButton
        aria-label='Close'
        onClick={onClose}
        size='small'
        sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
      >
        <IoClose size={22} />
      </IconButton>

      <DialogContent sx={{ pt: 4, pb: 3 }}>
        <Box display='flex' justifyContent='center' mb={2}>
          <CircularProgress size={44} thickness={4} />
        </Box>
        <Typography color='text.secondary' fontSize={15} fontWeight={500}>
          {friendly} Update to {newV}...
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
